/* @flow */

const getIndexInParent = ($el: HTMLElement, parent: HTMLElement) => (
    Array.from(parent.children).indexOf($el)
);

export default getIndexInParent;
